import React from 'react';
import { Header } from '@amzn/awsui-components-react-v3/polaris';
import { convertDateTimePretty } from '../../utils/ReadableConverter';

/**
 * Header of a versioned record naming its live version, when it was created and by whom. Used by
 * the base rates table.
 */

export interface VersionInfo {
  version: number;
  author: string;
  // ISO-8601 UTC timestamp; older versions may not have one.
  createdAt?: string;
}

export const versionSummary = ({ version, author, createdAt }: VersionInfo): string =>
  createdAt
    ? `Version ${version} · created ${convertDateTimePretty(createdAt)} by ${author}`
    : `Version ${version}, last changed by ${author}`;

const VersionHeader = ({
  title,
  record,
  actions,
}: {
  title: string;
  record: VersionInfo;
  actions?: React.ReactNode;
}): JSX.Element => (
  <Header variant="h2" description={versionSummary(record)} actions={actions}>
    {title}
  </Header>
);

export default VersionHeader;
